import { css } from '@emotion/core';
import { Box, Heading3 } from 'localmed-core';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { DiButton } from '../../../../../shared/components/DiComponents';
import InChair from '../../../../../shared/icons/InChair';
import { getGreetings } from '../../utils';
import { IStepProps } from '../schedulingWizard';
import { ContentWrapper, Wrapper } from '../styles';

interface Props extends IStepProps {}

export default function SchedulingLandingPage({ wizard }: Props) {
  useEffect(() => {
    if (wizard && wizard?.trackSchedulingEvent) {
      wizard.trackSchedulingEvent('Scheduling Landing Page', 'SchedulingLandingPage');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!wizard) return null;

  const { scheduleRequest } = wizard.values;

  return (
    <Wrapper
      css={css`
        text-align: center;
      `}
      alignItems="center"
    >
      <ContentWrapper>
        <Box>
          <InChair
            css={css`
              transform: initial;
              width: 235px;
            `}
          />

          <Heading3 fontSize={{ _: 'lg', lg: 'xxl' }}>
            <FormattedMessage
              id="scheduling.SchedulingLandingPage.message"
              defaultMessage={getGreetings(scheduleRequest)}
            />
          </Heading3>
        </Box>
      </ContentWrapper>
      <DiButton
        onClick={() => {
          if (wizard.values.start) {
            wizard.gotoNextStep();
          } else {
            wizard.form.change('start', true);
          }
        }}
      >
        <FormattedMessage
          id="scheduling.SchedulingLandingPage.startButton"
          defaultMessage="Start Scheduling an Appointment"
        />
      </DiButton>
    </Wrapper>
  );
}

SchedulingLandingPage.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  id: 'SCHEDULING_LANDING_PAGE',
};
